<template>
  <el-row>
    <el-row class="column-name" justify="start">
      <span>操作场景</span>
      <div class="navbar-right">
        <el-button type="info" plain size="minimum" @click="toAdd" :disabled="!addable">新增</el-button>
      </div>
    </el-row>
    <el-row>
      <athub-collapse v-show="records.length > 0">
        <athub-collapse-item :title="record.sequence + '、' + record.description" v-for="record in records" :key="record.jobplansceneid">
          <template slot="bar">
            <div>
              <el-button type="primary" plain size="minimum" @click.stop="toInsert(record)" :disabled="!addable">插入</el-button>
              <el-button type="warning" plain size="minimum" @click.stop="toEdit(record)" :disabled="!updatable">修改</el-button>
              <el-button type="danger" plain size="minimum" @click.stop="toDelete(record)" :disabled="!deletable">删除</el-button>
            </div>
          </template>
          <template>
            <el-row type="flex" justify="center" style="padding-left: 15px;padding-right: 15px;">
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <job-task-list :job-plan="jobPlan" :job-plan-scene="record" :title-class="{'column-name-blue': true}"
                               :addable="addable" :updatable="updatable" :deletable="deletable"
                               @switch-operation="switchOperation"></job-task-list>
              </el-col>
            </el-row>
          </template>
        </athub-collapse-item>
      </athub-collapse>
      <el-row v-show="records.length <= 0" style="height: 60px;line-height: 60px;text-align: center;">
        暂无数据
      </el-row>
    </el-row>

    <el-row>
      <el-dialog title="操作场景" :visible.sync="jobPlanSceneDialogVisible">
        <el-form ref="form" :model="form.model" :rules="form.rules">
          <el-row>
            <el-col :xs="24" :sm="24" :md="24" :lg="24">
              <el-form-item label="序号" prop="sequence">
                <el-input v-model="form.model.sequence" :disabled="true" size="small"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24">
              <el-form-item :label="'描述'" prop="description">
                <el-input v-model="form.model.description" type="textarea" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-row>
            <el-button @click="jobPlanSceneDialogVisible = false" size="small">取 消</el-button>
            <el-button type="primary" @click="save" size="small">确 定</el-button>
          </el-row>
        </div>
      </el-dialog>
    </el-row>
  </el-row>
</template>

<script>
  import { JobPlan } from '../mixins'
  import JobTaskList from '../jobtask/list'
  import { WorkOrderServer } from '@/api'
  import { AuthInfo } from "@/util/user/authInfo"
  import { merge } from "@/util/common";

  import AthubCollapse from '@/views/workorder/components/athub-collapse'
  import AthubCollapseItem from '@/views/workorder/components/athub-collapse-item'

  export default {
    name: "JobPlanSceneList",
    mixins: [JobPlan],
    components: {JobTaskList, AthubCollapse, AthubCollapseItem},
    props: {
      jobPlan: {},
      addable: {
        type: Boolean,
        default: false,
      },
      updatable: {
        type: Boolean,
        default: false,
      },
      deletable: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        records: [],
        jobPlanSceneDialogVisible: false,
        operation: '',
        form: {
          model: {
            jobplanid: '',
            sequence: '',
            description: '',
          },
          rules: {

          },
        }
      };
    },
    watch: {
      jobPlan: {
        immediate: true,
        deep: true,
        handler(val) {
          this.getJobPlanScenes();
        }
      }
    },
    methods: {
      getJobPlanScenes() {
        if (this.jobPlan.jobplanid != null) {
          WorkOrderServer.jobPlanScene.list({eq_jobplanid: this.jobPlan.jobplanid}).then((res) => {
            if (res.data.code === 200) {
              this.records = res.data.result;
            }
          });
        } else {
          this.records = [];
        }
      },
      toAdd() {
        WorkOrderServer.jobPlanScene.getMaxSequence(this.jobPlan.jobplanid).then((res) => {
          if (res.data.code === 200) {
            let max = res.data.result, next = max + 1;
            this.form.model = {
              jobplanid: this.jobPlan.jobplanid,
              sequence: next,
            };
            this.operation = 'add';
            this.jobPlanSceneDialogVisible = true;
          } else {
            this.$message.error(res.data.message);
          }
        });
      },
      toInsert(data) {
        let prev = data['sequence'];
        this.form.model = {
          jobplanid: this.jobPlan.jobplanid,
          sequence: prev,
        };
        this.operation = 'add';
        this.jobPlanSceneDialogVisible = true;
      },
      toEdit(data) {
        this.form.model = merge(true, {}, data);
        this.operation = 'edit';
        this.jobPlanSceneDialogVisible = true;
      },
      save() {
        this.$refs['form'].validate((res) => {
          if (res) {
            if (this.operation === 'add') {
              let data = merge(true, {}, this.form.model);
              data.enterby = AuthInfo.userName;
              data.enterbyname = AuthInfo.userRealName;
              data.enterdate = new Date().Format('yyyy-MM-dd hh:mm:ss');
              data.changeby = AuthInfo.userName;
              data.changebyname = AuthInfo.userRealName;
              data.changedate = new Date().Format('yyyy-MM-dd hh:mm:ss');
              WorkOrderServer.jobPlanScene.add(data).then((res) => {
                if (res.data.code === 200) {
                  this.$message.success('新增成功！');
                  this.jobPlanSceneDialogVisible = false;
                  this.getJobPlanScenes();
                }
              });
            } else if (this.operation === 'edit') {
              let data = merge(true, {}, this.form.model);
              data.changeby = AuthInfo.userName;
              data.changebyname = AuthInfo.userRealName;
              data.changedate = new Date().Format('yyyy-MM-dd hh:mm:ss');
              WorkOrderServer.jobPlanScene.update(data['jobplansceneid'], data).then((res) => {
                if (res.data.code === 200) {
                  this.$message.success('保存成功！');
                  this.jobPlanSceneDialogVisible = false;
                  this.getJobPlanScenes();
                }
              });
            }
          } else {
            return false;
          }
        });
      },
      toDelete(data) {
        this.$confirm('确定删除吗？', '删除提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          WorkOrderServer.jobPlanScene.delete(data['jobplansceneid'], {loading: true}).then((res) => {
            if (res.data.code === 200) {
              this.$message.success('删除成功！');
              this.getJobPlanScenes();
            } else {
              this.$message.error('删除失败！');
            }
          });
        })
      },
      switchOperation(operation) {
        this.$emit('switch-operation', operation);
      }
    },
  }
</script>

<style scoped>

</style>